import React from "react";
import digitalImg from "../../../assets/images/marketing-translation/digital.webp";
import tranditionalImg from "../../../assets/images/marketing-translation/traditional.webp";

function TranslationMedium() {
  return (
    <section className="bg-midBlue pt-16 pb-20 lg:pt-20 lg:pb-24">
      <div className="w-11/12 lg:w-8/12 xl:max-w-6xl 2xl:w-7/12 mx-auto">
        <h2 className="font-secondary font-semibold text-[34px] text-gray mb-8">Marketing Translation Services for Every Medium</h2>
        <p className="text-darkMist text-17">
          Tomedes’ marketing translation services fit for every medium. Whether it’s digital marketing or traditional marketing, we can translate and localize your content, website, or social media.
        </p>
        <div className="divider border-b border-gray my-14 border-opacity-25 lg:w-[120%] lg:ml-[-10%]"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24">
          <div>
            <img src={digitalImg} alt="digital" className="hidden md:block mt-6 lg:mt-0" />
            <div>
              <h3 className="font-secondary font-semibold text-24 text-orange mt-7 lg:mt-9 mb-4">Digital</h3>
              <p className="text-darkMist text-17">
                Tomedes supports all digital mediums of marketing, such as search engines, social media ads, email marketing, and mobile apps. Rest assured that your documents, ads, and all other
                marketing materials can be tailored to your target audience’s language.
              </p>
            </div>
          </div>
          <div>
            <img src={tranditionalImg} alt="traditional" className="hidden md:block mt-6 lg:mt-0" />
            <div>
              <h3 className="font-secondary font-semibold text-24 text-orange mt-7 lg:mt-9 mb-4">Traditional</h3>
              <p className="text-darkMist text-17">
                For print, radio, television, and direct mail marketing, Tomedes has mastered the science of conversion through language. Whether it’s for your documents, commercials, and other types
                of marketing materials, our translations can better convert your customers by connecting with them in their language.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TranslationMedium;
